import { useFormik } from "formik";
import { getNewPhoneOTP } from "../../../../api/custAccountApi";
import { handleApiError } from "../../../../utils/errors";
import { MESSAGE } from "../../../../constants";
import { getTMXSessionID } from "../../../../utils";

export const getGetOtpForm = (verifiedPhone, email, userID, encryptVerifiedPhoneToken, successCallback, showLoading, hideLoading) => {
  return useFormik({
    initialValues: {
      otpChannel: "sms",
      phone: verifiedPhone || ""
    },
    onSubmit: (values, actions) => {
      const phone = values.phone.replace(/[^0-9]/g, "")
      showLoading();
      getNewPhoneOTP(email, phone, values.otpChannel, userID, getTMXSessionID(), encryptVerifiedPhoneToken)
        .then(({ response, error }) => {
          if (response) { // otp successfully sent
            actions.setStatus("");
            successCallback(phone, response);
            actions.resetForm();
          } else {
            const errorMessage = handleApiError(error, "secure your account - get otp");
            actions.setStatus([errorMessage]);
          }

          hideLoading();
        });
    },
  });
};

export const getVerifyOtpForm = (apiCall, successCallback, failureCallback, showLoading, hideLoading) => {
  return useFormik({
    initialValues: {
      otp: ""
    },
    validateOnChange: true,
    validateOnBlur: true,
    validate: (v) => {
      if (!(v?.otp?.length > 0)) {
        return { otp: [MESSAGE.OTP_MISSING] };
      }
      if (v?.otp?.length !== 6) {
        return { otp: [MESSAGE.OTP_INCORRECT_LENGTH] };
      }
      return true;
    },
    onSubmit: (values, actions) => {
      showLoading();
      apiCall(values)
        .then(({ response, error }) => {
          if (response) { // otp successfully sent
            actions.setStatus("");
            successCallback(response);
            actions.resetForm();
          } else {
            failureCallback(error);
          }
          hideLoading();
        });
    },
  });
};
